export default __webpack_public_path__ + "static/media/telegram.ecc9c70f.svg";